import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import TextHeader from "../../components/estudiantes/TextHeader";
import ImageHeader from "../../components/estudiantes/ImageHeader";
import fachada from "../../assets/fachada_escuela.jpg";
import Form from "react-bootstrap/Form";
import InputIdentificacion from "../../components/estudiantes/InputIdentificacion";
import MotivosDeAtencion from "../../components/estudiantes/MotivosDeAtencion";
import Boton from "../../components/estudiantes/Boton";
import {
  validateRut,
  validatePasaporte,
  validateMotivo,
} from "../../validations/ticketValidation";
import { postAtencion } from "../../services/apis_estudiante";

const styles = {
  body: {
    fontFamily: "var(--font-estudiantes)",
    backgroundColor: "var(--color-background)",
    height: "100dvh",
  },
  backgroundBlue: {
    backgroundColor: "var(--color-primary)",
  },
  scrollable: {
    overflowY: "auto",
    height: "100dvh",
  },
};

function FormularioAtencion() {
  const [identificacion, setIdentificacion] = useState("");
  const [modo, setModo] = useState("rut");
  const [motivo, setMotivo] = useState("");
  const [error, setError] = useState("");
  const [errorMotivo, setErrorMotivo] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (modo === "rut") {
      let msg = validateRut(identificacion);
      if (msg) {
        setError(msg);
        return;
      }
    } else if (modo === "pasaporte") {
      let msg = validatePasaporte(identificacion);
      if (msg) {
        setError(msg);
        return;
      }
    }
    let msgMotivo = validateMotivo(motivo);
    if (msgMotivo) {
      setErrorMotivo(msgMotivo);
      return;
    }

    // si todo bien
    setError("");
    setErrorMotivo("");

    const payload = {
      rut: identificacion.replace(/[-.]/g, ""),
      pasaporte: modo === "pasaporte" ? "True" : "False",
      motivo,
    };

    console.log("Payload:", payload);
    try {
      console.log("Enviando atención con payload:", payload);
      const data = await postAtencion(payload);
      sessionStorage.setItem("ticketActivo", JSON.stringify(data));
      navigate("/espera", { state: { ...data } });
      console.log("Respuesta del backend:", data);
    } catch (error) {
      console.error("Error al enviar atención:", error);
    }
  };

  return (
    <Container fluid className="p-0 m-0 w-100" style={styles.body}>
      <Row className="g-0 my-0 p-0 w-100 h-100">
        {/* Columna izquierda y parte superior */}
        <Col
          xs={12}
          md={6}
          className="p-0 m-0 h-md-100"
          style={styles.backgroundBlue}
        >
          <TextHeader title="¡Bienvenid@ al Área de Administración Docente!" />
          <ImageHeader route={fachada} alt="Fachada de la escuela" />
        </Col>

        {/* Columna derecha */}
        <Col
          xs={12}
          md={6}
          className="my-auto my-md-0 h-md-100 p-3 px-md-5 py-0 d-none d-md-block "
          style={styles.scrollable}
        >
          <Form
            className="py-5 my-0 w-100 d-flex flex-column"
            onSubmit={handleSubmit}
          >
            <InputIdentificacion
              identificacion={identificacion}
              setIdentificacion={setIdentificacion}
              modo={modo}
              setModo={setModo}
              error={error}
              setError={setError}
            />
            <Form.Group controlId={motivo}>
              <Form.Label>Selecciona el motivo de atención:</Form.Label>
              <MotivosDeAtencion
                onSeleccion={(motivoSeleccionado) => {
                  setMotivo(motivoSeleccionado);
                  setErrorMotivo("");
                }}
                error={errorMotivo}
              />
            </Form.Group>
            <Boton text="Tomar número" />
          </Form>
        </Col>

        {/* Parte inferior */}
        <Col xs={12} md={6} className="d-block d-md-none p-0">
          <div className="position-relative">
            <div
              className="rounded-top-5 shadow p-4 p-sm-5"
              style={{
                marginTop: "-2.5rem", // sube el bloque para superponer la imagen
                position: "relative",
                zIndex: 10, // asegura que quede por encima de la imagen
                backgroundColor: "var(--color-background)",
              }}
            >
              <Form
                className="py-3 w-100 d-flex flex-column"
                onSubmit={handleSubmit}
              >
                <InputIdentificacion
                  identificacion={identificacion}
                  setIdentificacion={setIdentificacion}
                  modo={modo}
                  setModo={setModo}
                  error={error}
                  setError={setError}
                />
                <Form.Group controlId={motivo}>
                  <Form.Label>Selecciona el motivo de atención:</Form.Label>
                  <MotivosDeAtencion
                    onSeleccion={(motivoSeleccionado) => {
                      setMotivo(motivoSeleccionado);
                      setErrorMotivo("");
                    }}
                    error={errorMotivo}
                  />
                </Form.Group>
                <Boton text="Tomar número" />
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
export default FormularioAtencion;
